import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1367d9f9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "element-outline tr_row" }
const _hoisted_2 = { style: {"flex":"2"} }
const _hoisted_3 = {
  class: "switch-wrapper",
  style: {"flex":"3"}
}
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { style: {"flex":"2"} }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { style: {"flex":"2"} }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { style: {"flex":"2"} }

import { ref, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore } from '@/store'
import { PPTElementOutline } from '@/types/slides'
import useHistorySnapshot from '@/hooks/useHistorySnapshot'
import { useI18n } from 'vue-i18n'
import ColorButton from './ColorButton.vue'
import ColorPicker from '@/components/ColorPicker/index.vue'
import {
  InputNumber,
  Popover,
  Select,
  Switch,
} from 'ant-design-vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ElementOutline',
  props: {
  fixed: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const { t, locale } = useI18n()

const SelectOption = Select.Option



const slidesStore = useSlidesStore()
const { handleElement } = storeToRefs(useMainStore())

const outline = ref<PPTElementOutline>()
const hasOutline = ref(false)

watch(handleElement, () => {
  if (!handleElement.value) return
  outline.value = 'outline' in handleElement.value ? handleElement.value.outline : undefined
  hasOutline.value = !!outline.value
}, { deep: true, immediate: true })

const { addHistorySnapshot } = useHistorySnapshot()

const updateOutline = (outlineProps: Partial<PPTElementOutline>) => {
  if (!handleElement.value) return
  const props = { outline: { ...outline.value, ...outlineProps } }
  slidesStore.updateElement({ id: handleElement.value.id, props })
  addHistorySnapshot()
}

const toggleOutline = (checked: boolean) => {
  if (!handleElement.value) return
  if (checked) {
    const _outline: PPTElementOutline = { width: 2, color: '#000', style: 'solid' }
    slidesStore.updateElement({ id: handleElement.value.id, props: { outline: _outline } })
  }
  else {
    slidesStore.removeElementProps({ id: handleElement.value.id, propName: 'outline' })
  }
  addHistorySnapshot()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!__props.fixed)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "row",
          style: _normalizeStyle(hasOutline.value ? 'margin-bottom: 10px;' : '')
        }, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t(`editor.toolbar.common.elementOutline.border`)) + "：", 1),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(Switch), {
              checked: hasOutline.value,
              onChange: _cache[0] || (_cache[0] = checked => toggleOutline(checked as boolean))
            }, null, 8, ["checked"])
          ])
        ], 4))
      : _createCommentVNode("", true),
    (hasOutline.value && outline.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t(`editor.toolbar.common.elementOutline.borderStyle`)) + "：", 1),
            _createVNode(_unref(Select), {
              style: {"flex":"3"},
              value: outline.value.style,
              onChange: _cache[1] || (_cache[1] = value => updateOutline({ style: value as 'dashed' | 'solid' }))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(SelectOption), { value: "solid" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(`editor.toolbar.common.elementOutline.solid`)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(SelectOption), { value: "dashed" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(`editor.toolbar.common.elementOutline.dashes`)), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t(`editor.toolbar.common.elementOutline.borderColor`)) + "：", 1),
            _createVNode(_unref(Popover), { trigger: "click" }, {
              content: _withCtx(() => [
                _createVNode(ColorPicker, {
                  modelValue: outline.value.color,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = value => updateOutline({ color: value }))
                }, null, 8, ["modelValue"])
              ]),
              default: _withCtx(() => [
                _createVNode(ColorButton, {
                  color: outline.value.color || '#000',
                  style: {"flex":"3"}
                }, null, 8, ["color"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t(`editor.toolbar.common.elementOutline.borderWeight`)) + "：", 1),
            _createVNode(_unref(InputNumber), {
              value: outline.value.width,
              onChange: _cache[3] || (_cache[3] = value => updateOutline({ width: value as number })),
              style: {"flex":"3"}
            }, null, 8, ["value"])
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})